import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { fontRamp } from "@faire/web--source/slate/Typography";
export var buildTypographyDesignTokensFromFontRamp = function() {
    return Object.entries(fontRamp.fonts).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var valueString = Object.entries(value).map(function(param) {
            var _param = _sliced_to_array(param, 2), styleKey = _param[0], styleValue = _param[1];
            if (styleKey === "font-family") {
                return "".concat(styleValue);
            }
            return "".concat(styleKey, ": ").concat(styleValue);
        }).join("; ");
        return {
            name: key,
            value: "".concat(valueString)
        };
    });
};
